module.exports = __webpack_public_path__ + "static/media/005_Forum.a60b988b.mp4";